<template>
	<b-tabs id="portability-steps-tabs" fill card pills vertical>
		<b-tab title="Personas Físicas" variant="info" active>
			<!-- <div class="padded"> -->

			<h5>1. Obtén tu NIP</h5>

			<p>
				Hay dos formas de obtener tu NIP:
			</p>
			<ul>
				<li><b>Por llamada:</b> Llama al 051 y sigue las instrucciones para obtener tu NIP.</li>
				<li><b>Por SMS:</b> Envía un mensaje de texto con la palabra NIP al 051 (sin costo).</li>
			</ul>

			<br />

			<h5>2. Reúne los requisitos</h5>
			<p>
				Para ejercer tu derecho solo requieres el NIP vigente* y una identificación oficial que puede
				ser:
			</p>
			<ul>
				<li>Credencial para votar vigente expedida por el Instituto Federal Electoral (IFE) o por el
					Instituto
					Nacional
					Electoral (INE)</li>
				<li>Pasaporte vigente</li>
				<li>Cédula Profesional</li>
				<li>Cartilla del Servicio Militar Nacional</li>
				<li>Certificado de Matrícula Consular</li>
				<li>Documento migratorio vigente emitido por autoridad competente o, en su caso, prórroga o
					refrendo
					migratorio
				</li>
				<li>Identificaciones vigentes con fotografía y firma expedidas por la Federación, los Estados,
					el
					Distrito
					Federal o los Municipios (por ejemplo: IMSS, ISSTE, SEP, DIF, INAPAM)</li>
				<li>CURP (Clave Única de Registro de Población).</li>
			</ul>

			<p class="text-sm">
				*Una vez otorgado el NIP, este tendrá una vigencia de 5 días a partir de la fecha en que fue
				solicitado.<br />
				Nota: para menores de edad se acepta como identificación, aquella que sea vigente con fotografía
				y firma
				expedida por la Federación, los Estados, el Distrito Federal o los Municipios.
			</p>

			<br />

			<h5>3. Llena la solicitud de portabilidad</h5>

			<p>
				Una vez obtenido el NIP, debes iniciar el trámite de portabilidad, para ello solo llena el
				formulario que aparece en esta misma página.
			</p>

			<br>

			<p>
				Si ya eres cliente Clave Verde, contacta a tu Ejecutivo de Cuenta o ingresa a <router-link
					:to="{ name: 'Mi cuenta' }">Mi Cuenta</router-link>. Ahí podrás confirmar el resultado de tu
				portabilidad 1 o 2 días hábiles después de llenar el formulario.
			</p>

			<br>

			<p class="note">
				¿Aún no eres cliente Clave Verde? <b>Crea tu cuenta</b> y <b>registra tu SIM</b> para monitorear
				el estatus de tu portabilidad y acceder a más funcionalidades.
			</p>
			<!-- </div> -->

		</b-tab>
		<b-tab title="Personas Morales" variant="info">
			<!-- <div class="padded"> -->
			<h5>1. Reúne los requisitos:</h5>
			<p>
				El trámite solo podrá ser realizado por el Representante Legal o Apoderado de la empresa, quien
				deberá
				presentar:
			</p>
			<ul>
				<li>Poder Notarial que conste en escritura pública.</li>
				<li>
					Identificación oficial que puede ser:
					<ul>
						<li>Credencial para votar vigente expedida por el Instituto Federal Electoral (IFE) o
							por el
							Instituto
							Nacional Electoral (INE)</li>
						<li>Pasaporte vigente</li>
						<li>Cédula Profesional</li>
						<li>Cartilla del Servicio Militar Nacional</li>
						<li>Certificado de Matrícula Consular</li>
						<li>Documento migratorio vigente emitido por autoridad competente, en su caso, prórroga
							o
							refrendo
							migratorio</li>
						<li>Identificaciones vigentes con fotografía y firma, expedida por la Federación, los
							Estados,
							el Distrito
							Federal o los Municipios (por ejemplo: IMSS, ISSTE, SEP, DIF, INAPAM)</li>
					</ul>
					<p>
						Para dependencias, entidades gubernamentales, sujetos u órganos de derecho público es la
						Identificación
						Oficial del funcionario en conjunto con la documentación que acredite que el funcionario
						cuenta
						con
						facultades para realizar procesos de contratación para la adquisición de servicios a
						nombre
						de
						la
						dependencia.
					</p>
				</li>
			</ul>

			<br />
			<h5>2. Si ya eres cliente Clave Verde, contacta a tu Ejecutivo de Cuenta o ingresa a Clave Verde
				Empresas.</h5>
			<p>
				2.1 Si aún no eres cliente ingresa a Clave Verde Empresas, proporciona tus datos y te
				contactaremos
				lo
				antes posible. Si ya eres cliente contacta a tu Ejecutivo.
			</p>
			<p class="mt-2">
				Proporciona al Ejecutivo de Cuenta la información que te solicite para el llenado de la
				Solicitud de
				Portabilidad.
			</p>
			<p class="mt-2">
				2.2 El Ejecutivo de Cuenta agendará una fecha para visitarte, momento en el que deberás
				presentar el
				Poder Notarial, tu identificación oficial y firmar la solicitud que el Ejecutivo llevará
				previamente
				llenada.
			</p>

			<br />
			<h5>
				3. Una vez firmada la Solicitud e ingresada al sistema, recibirás dos Mensajes de Texto (SMS) en
				cada
				una de las líneas a portar: el primero informando que el trámite esta en proceso e indicando el
				ID
				de
				portabilidad con el que podrás consultar el estatus del trámite de dicha línea, y el segundo
				informando
				la fecha de ejecución de la portación de dicha línea.
			</h5>
			<p>
				<a target="_blank" href="https://www.portabilidad.mx/">Consulta el estatus del trámite.</a>
			</p>

			<br />
			<h5>
				4. En la misma visita el Ejecutivo de Cuenta te entregará un Chip (SIM card) por línea que
				deseas
				portar, los cuales deberán insertarse en los equipos una vez que se ejecute la portabilidad para
				poder
				disfrutar de los servicios de Clave Verde.
			</h5>

			<p class="mt-3 text-sm">
				Nota 1: En caso de que tu Solicitud de Portabilidad sea rechazada recibirás de Clave Verde un
				Mensaje de
				Texto (SMS) notificándotelo, a fin de que acudas nuevamente a un punto de contacto Clave Verde
				para
				corregir el motivo que haya originado el rechazo.
			</p>
			<p class="mt-2 text-sm">
				Nota 2: Como regla general, en caso de realizar tu portabilidad en horario y día hábil, ésta se
				programará para ejecución a las 2:00 a.m. del día siguiente. En caso que requieras que ésta se
				realice
				en una fecha distinta posterior, podrás elegir la fecha efectiva de la portabilidad la cual no
				podrá
				exceder de 5 días hábiles a partir de que ingreses tu solicitud.
			</p>
			<p class="mt-2 text-sm">
				RESOLUCIÓN IFT.DOF 12/11/14
			</p>
			<!-- </div> -->
		</b-tab>
	</b-tabs>
</template>

<script>
export default {
	data() {
		return {
			portPersona: 'fisica',
		}
	},
}
</script>


<style lang="scss">
@import '@/scss/app.scss';
#portability-steps-tabs {
	.col-auto {
		@media screen and (max-width: 520px) {
			margin-top: -2.5em;
			width: 100%;
			text-align: center;
		}
	}

	.nav-pills .nav-link.active,
	.nav-pills .show>.nav-link {
		background-color: $secondary;
	}

}
</style>